import { LitElement, html, css } from 'lit';
import '../app-gap/app-gap.js';
export class AppFragment extends LitElement {
    static get properties() {
        return {
            appName: { type: String, attribute: 'app-name' },
            jwtToken: { type: String, attribute: 'jwt-token' },
            navigationRoute: { type: String, attribute: 'navigation-route' },
            theme: { type: String, attribute: 'theme' },
            language: { type: String, attribute: 'language' },
            options: { type: Object },
            component: { type: String },
        };
    }
    static get styles() {
        return [
            css `
        :host {
          display: block;
          height: 100%;
          width: 100%;
        }
      `,
        ];
    }
    constructor() {
        super();
        this.language = 'en';
        this.jwtToken = '';
        this.navigationRoute = '';
        this.component = '';
    }
    get appGap() {
        return this.shadowRoot.querySelector('app-gap');
    }
    connectedCallback() {
        super.connectedCallback();
        this.fragmentAttributes = window.fragments.find(f => f.id === this.appName);
        window.addEventListener('synapse-frame-event', e => {
            this.appGap.dispatchEvent(new CustomEvent('synapse-frame-event', { detail: e.detail, bubbles: true }));
        });
    }
    render() {
        return html ` <app-gap
      id=${this.fragmentAttributes?.id}
      module="${this.fragmentAttributes?.uiBundle}"
      component="${this.fragmentAttributes?.component}"
      endpoint="${this.fragmentAttributes?.endpoint}"
      prefix="${this.fragmentAttributes?.prefix}"
      options="${JSON.stringify({ ...this.fragmentAttributes?.options, ...this.options })}"
      jwt-token="${this.jwtToken}"
      navigation-route="${this.navigationRoute}"
      language="${this.language}"
      theme=${this.theme}
      features=${JSON.stringify(this.fragmentAttributes?.features)}
      @synapse-app-event=${this.handleSynapseAppEvent}
      extra-scripts="${AppFragment.getExtraScripts()}"
    ></app-gap>`;
    }
    /** @param {CustomEvent} e */
    handleSynapseAppEvent(e) {
        this.dispatchEvent(new CustomEvent('synapse-app-fragment-event', {
            detail: { fragment: this.fragmentAttributes?.id, ...e.detail },
        }));
    }
    static getExtraScripts() {
        try {
            return Array.from(window.document.body.querySelectorAll('.synapse-extra-script'))
                .map(el => el.getAttribute('src')).join(',') || null;
        }
        catch (e) {
            console.warn(e);
            return null;
        }
    }
}
window.customElements.define('app-fragment', AppFragment);
